export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5596.4e9eac22.jpg";